import { createClient } from "@lib/supabase/client";

const PASSWORD_RECOVERY_PENDING_KEY = "komut_password_recovery_pending";

/** Recovery exchanged a session but the user has not set a new password yet. */
export function markPasswordRecoveryPending(): void {
  sessionStorage.setItem(PASSWORD_RECOVERY_PENDING_KEY, "1");
}

export function clearPasswordRecoveryPending(): void {
  sessionStorage.removeItem(PASSWORD_RECOVERY_PENDING_KEY);
}

export function isPasswordRecoveryPending(): boolean {
  return sessionStorage.getItem(PASSWORD_RECOVERY_PENDING_KEY) === "1";
}

/** Drop the temporary recovery session when the user leaves reset without finishing. */
export async function clearPasswordRecoverySession(): Promise<void> {
  clearPasswordRecoveryPending();
  const supabase = createClient();
  await supabase.auth.signOut({ scope: "local" });
}
